;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { MdClose } from 'react-icons/md';
import { Button } from 'reactstrap';
import dayjs from '../../../utils/dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import axiosInstance from '../../../utils/axios';
import { logSentryError } from '../../../utils/logSentry';
import DeleteModal from '../DeleteModal';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

dayjs.extend(localizedFormat);

type Props = {
  notification: MySynergieNotification;
  deleteButton?: boolean;
  refetchData?: () => Promise<void>;
  dictionary: Partial<Dictionaries>;
};
const NotificationItem = ({ notification, deleteButton = false, refetchData, dictionary }: Props) => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { push } = useRouter();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const { created, type, readAt, data, eventId } = notification;

  let notificationTitle;
  let notificationMessage;
  let notificationLink;

  const dayjsDate = dayjs(created);
  const date = `${dayjsDate.format('LL')} ${formatMessage({
    id: 'at',
  })} ${dayjsDate.format('LT')}`;

  const toggleDeleteModal = (e) => {
    e.stopPropagation();
    setDeleteModalOpen((prev) => !prev);
  };

  const handleClick = async () => {
    try {
      await axiosInstance.patch(`/notifications/history/`, {
        eventIds: [eventId],
        read: true,
      });
      refetchData?.();
    } catch (error) {
      logSentryError(error);
    }
    push(notificationLink);
  };

  switch (type) {
    case 'savedSearch_newMatch_push':
    case 'savedSearch_newMatch_email':
      // If the saved search itself is deleted but the notification still exists, don't render it.
      if (!data.savedSearch) return null;
      notificationTitle = `${data.jobs?.length} ${formatMessage({
        id: 'savedSearch_newMatch_title',
      })}`;
      notificationMessage = formatMessage(
        { id: 'savedSearch_newMatch_message' },
        {
          title: data.savedSearch.name,
        }
      );
      notificationLink = `${data.savedSearch.url}&sort=updateDate`;
      break;
    default:
      return null;
  }

  return (
    <>
      {deleteModalOpen && (
        <DeleteModal
          dictionary={dictionary}
          isOpen={deleteModalOpen}
          toggle={toggleDeleteModal}
          url="/notifications/history"
          data={{ eventIds: [eventId] }}
          onDeleted={() => refetchData?.()}
          title="notification_save_jobsearch_delete_modal_title"
          message="notification_save_jobsearch_delete_confirmation"
        />
      )}
      <div
        className={`notification-item p-3 mb-3 ${readAt ? '' : 'unread'}`}
        onClick={handleClick}
        onKeyDown={handleClick}
        role="button"
        tabIndex={0}
      >
        <div className="d-flex justify-content-between align-items-center mb-1">
          {!readAt && <div className="unread-dot" />}
          {notificationTitle && <h3 className="mb-0 mx-3 mx-md-4">{notificationTitle}</h3>}
          {deleteButton && (
            <Button className="button-mysynergie-icon py-0" onClick={toggleDeleteModal}>
              <MdClose />
            </Button>
          )}
        </div>
        {notificationMessage && <p className="mb-1 mx-3 mx-md-4">{notificationMessage}</p>}
        <p className="timestamp mb-0 mx-3 mx-md-4">{capitalizeFirstLetter(date)}</p>
      </div>
    </>
  );
};

export default NotificationItem;
